require('./../../uPortal/Content/css/default.css');

import initPolyfill from './../../uPortal/Content/js/Polyfill';
import { } from './../../uPortal/Core/Panels/RTStartPanel/Js'

import { } from './../../uPortal/Core/Pages/SectionPage/Js';
import { } from './../../uPortal/Core/Pages/NewsPage/Js';

import { } from './../../Core/Panels/NotificationPanel/Js'


import initAjaxFormsScripts     from "./../../uPortal/Content/js/AjaxForms";
import initHeroPanel            from './../../uPortal/Core/Panels/HeroPanel/Js';
import initVideoPanel           from './../../uPortal/Core/Panels/VideoPanel/Js';
import initNewsletterPanel      from './../../uPortal/Core/Panels/NewsletterPanel/Js';
import toggleQuestion           from './../../uPortal/Core/Panels/FaqPanel/Js';
import imageCarouselPanel       from './../../Core/Panels/imageCarouselPanel/Js';
import contactForm              from './../../Core/Panels/ContactFormPanel/Js';

import initMobileMenu           from "./../../uPortal/Core/Shared/Navigation/Js";
import initAutoSuggestion       from './../../uPortal/Core/Shared/AutoSuggestions/Js';
import scrollspy                from './../../uPortal/Content/js/Plugins/Scrollspy';
import initCustomFooter         from './../../Core/Shared/CustomFooter/Js';
import initCustomHeader         from './../../Core/Shared/CustomHeader/Js';
import initSearchResult         from './../../uPortal/Core/Pages/SearchPage/Js';
import initCookieDisclaimer from './../../uPortal/Core/Shared/CookieDisclaimer/Js';
import initCustomTopImage       from './../../Core/Shared/TopImage/Js';

initPolyfill();
initVideoPanel();
initNewsletterPanel();
initAjaxFormsScripts();
initMobileMenu();
toggleQuestion();
contactForm();
initHeroPanel();
//initTopImage();
initSearchResult();
initAutoSuggestion();
initCustomFooter();
initCustomHeader();
initCookieDisclaimer();
initCustomTopImage();

imageCarouselPanel.init();
scrollspy.init('.js-tracking-area');

//should be in the end for overriding all css included inside imported js
require('./../css/styles.css');


// WEBPACK FOOTER //
// ./Content/js/index.js